import { useIntl } from "react-intl";
import { SearchableSelect } from "@/components/design/SearchableSelect";
import { MOCK_ANLASS_OPTIONS } from "./project-mock-data";

// Der Anlass ist eine Auswahl aus sechs festen Kategorien, mehr nicht. Sechs
// Kacheln auf einer eigenen Seite waren ein ganzer Schritt für eine einzige
// Entscheidung.
//
// Bewusst SearchableSelect mit `searchable={false}` statt des nativen Select:
// die Liste soll aussehen wie der Rest der App, nicht wie das Betriebssystem.
// Das Suchfeld bleibt aus, weil Lesen bei sechs Einträgen schneller ist als
// Tippen.

export function ProjectAnlassField({
  value,
  onChange,
  readOnly = false,
}: {
  value: string | null;
  onChange: (id: string) => void;
  readOnly?: boolean;
}) {
  const intl = useIntl();
  const current = MOCK_ANLASS_OPTIONS.find((o) => o.id === value);

  return (
    <div>
      <SearchableSelect
        id="project-anlass"
        value={value}
        onChange={onChange}
        searchable={false}
        disabled={readOnly}
        options={MOCK_ANLASS_OPTIONS.map((o) => ({ value: o.id, label: intl.formatMessage(o.title) }))}
        placeholder={intl.formatMessage({ id: "project.anlass.placeholder", defaultMessage: "Anlass wählen" })}
        ariaLabel={intl.formatMessage({ id: "project.facet.anlass.label", defaultMessage: "Anlass" })}
      />
      {current ? (
        <p id="project-anlass-desc" className="mt-1.5 smycles-field-meta leading-snug text-ink-muted">{intl.formatMessage(current.desc)}</p>
      ) : null}
    </div>
  );
}
